import { render } from "./Mallki.vue?vue&type=template&id=3b608d69&scoped=true"
import script from "./Mallki.vue?vue&type=script&lang=ts"
export * from "./Mallki.vue?vue&type=script&lang=ts"

import "./Mallki.vue?vue&type=style&index=0&id=3b608d69&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b608d69"

export default script